// Tabbed Content
$('.tabcontent').hide();
$('#' + $('.contenttabs > button.active').attr('id') + '-content').show();

$('.contenttabs > .tab').bind('click', function () {
  $('.contenttabs > .tab').removeClass('active');
  $(this).addClass('active');
  $('.tabcontent').hide();
  $('#' + $(this).attr('id') + '-content').show();
});
